import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { ClickableCard } from './ClickableCard';

type DetailColumnProps = {
  label: string | ReactNode;
  input: string | ReactNode;
  fontSize?: number;
  icon?: ReactNode;
  iconBackgroundColor?: string;
  helperText?: string | ReactNode;
  onClick?: () => void;
  zIndex?: number;
  endElement?: ReactNode;
  disabled?: boolean;
  disabledMessage?: string;
};

const DetailColumn = (props: DetailColumnProps) => {
  const {
    label,
    input,
    fontSize,
    helperText,
    icon,
    iconBackgroundColor,
    onClick,
    zIndex,
    disabled = false,
    disabledMessage,
    endElement,
  } = props;
  const valueFontSize = fontSize ?? 12;
  const labelFontSize = valueFontSize - 2;
  const helperTextFontSize = valueFontSize - 5;

  return (
    <ClickableCard
      onClick={onClick}
      sxPaper={{ zIndex: zIndex ?? 'auto' }}
      disabled={disabled}
      disabledMessage={disabledMessage}
    >
      <Stack
        direction="row"
        spacing={1.5}
        bgcolor="white"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ overflowWrap: 'anywhere' }}
      >
        {icon && (
          <Box
            sx={{
              background: iconBackgroundColor,
              borderRadius: '100%',
              padding: 1,
              display: 'flex',
            }}
          >
            {icon}
          </Box>
        )}

        <Stack direction="row" spacing={0.5}>
          <Stack direction="column">
            <Typography variant="caption" color="text.secondary" fontSize={labelFontSize}>
              {label}
            </Typography>
            <Typography
              variant="h6"
              color="text.primary"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              fontSize={valueFontSize}
            >
              {input}
              {/* {input && typeof input === 'string' && input.length > 18
                ? `${input.substring(0, 18)}...`
                : input} */}
            </Typography>

            <Typography variant="body2" color="text.secondary" fontSize={helperTextFontSize}>
              {helperText}
            </Typography>
          </Stack>
          {endElement ?? null}
        </Stack>
      </Stack>
    </ClickableCard>
  );
};
export default DetailColumn;
